import React from 'react';
import './Hero.css';

const Hero = () => {
  // Add your hero image to public/images/hero-image.png
  // Supported formats: .png, .jpg, .jpeg, .svg
  const heroImage = '/images/hero-image.png';

  return (
    <section
      id="hero"
      className="hero"
    >
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-greeting">Hey there!</h1>
            <div className="hero-description">
              <p className="hero-intro">
                I'm <span className="hero-name-inline">Mina Beiki</span> and this is my personal website to showcase my programming experience, projects, and illustrations all in one place.
              </p>
              <p>
                I'm a software developer and I also love designing, which is why in my free time I create illustrations and UI designs. You can find more about it all here.
              </p>
              <p>
                Feel free to contact me. I'm always open to new connections! 😊
              </p>
            </div>
          </div>
          <div className="hero-image">
            <div className="image-wrapper">
              <img
                src={heroImage}
                alt="Mina - Software Developer"
                className="hero-img"
                onError={(e) => {
                  // Hide image if it doesn't exist
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = '<div style="padding: 40px; text-align: center; color: #999;">Add your image to public/images/hero-image.png</div>';
                }}
              />
            </div>
          </div>
        </div>
        <div className="scroll-indicator">
          <p className="scroll-indicator-label">scroll down to continue...</p>
          <div className="scroll-indicator-arrow-wrap" aria-hidden="true">
            <div className="scroll-arrow"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
